import api from '~/api/client';

export const CONSUMER_API_PATH = `${api.API_BASE_PATH}/consumer-portal`;

export function fetchBrandingData() {
  const topLevelDomain = window.location.hostname.split('.').splice(-2).join('.');
  return api.baseClient.get(`${api.API_BASE_PATH}/meta/consumer-branding/?domain=${topLevelDomain}`);
}
